// project
import { Graph, GraphNode } from "@/psychlab/types/graph";
import { Dictionary } from "@/utils/types";
import { Scene } from "@/psychlab/types/scene";
import { Form } from "@/psychlab/types/form";
import { Gallery } from "@/psychlab/types/gallery";
import { AssetPointer } from "@/psychlab/types/assets";
// local
import { getLatestAssetVersions } from "./getLatestAssetVersions";

type CognitiveTestParams = {
	useAsset:boolean;
	asset?:AssetPointer<any>;
};

type NodeResult = {
	assetRefs:string[];
	outdated:boolean; // outdated refs

};

type ReferenceResult = {
	nodes:Dictionary<NodeResult>;
};


export const getReferencedAssets = (graph:Graph) => {
	const refs:Dictionary<string[]> = {};
	Object.keys(graph.nodes)
	.forEach(k => {
		refs[k] = getReferencedNodeAssets(graph.nodes[k]);
	});

	const assets:string[] = [];

	Object.keys(refs)
	.forEach(k => {
		refs[k].forEach(r => {
			assets.push(r.split("@")[0]);
		});
	});

	return {
		nodes:refs,
		assets:Array.from(new Set(assets))
	};
};

export const getReferencedNodeAssets = (node:GraphNode<any>) => {
	if(node.type === "Form"){
		return getFormRefs(node.parameters["asset"]);
	}
	if(node.type === "Scene"){
		return getSceneRefs(node.parameters);
	}
	if(node.type === "CognitiveTest"){
		return getCognitiveTestRefs(node.parameters);
	}
	if(node.type === "Gallery"){
		return getGalleryRefs(node.parameters["asset"]);
	}
	return [];
};

const getSceneRefs = (scene:Scene) => {
	const refs:string[] = [];
	scene.points
	.forEach(point => {
		if(!point.form){ return; }
		if((point.form as any)["ref"]){
			refs.push.apply(refs, getFormRefs(point.form as AssetPointer<Form>));
		}
	});
	return refs;
};

const getFormRefs = (form:AssetPointer<Form>|undefined) => {
	if(!form) return [];

	if(form.ref){
		return [
			`${form.ref.asset}@${form.ref.version}`
		];
	}
	return [];
};

const getCognitiveTestRefs = (p:CognitiveTestParams) => {
	if(!p.useAsset){ return []; }
	if(!p.asset || !p.asset.ref){ return []; }
	return [
		`${p.asset.ref.asset}@${p.asset.ref.version}`
	];
};

const getGalleryRefs = (g:AssetPointer<Gallery>|undefined) => {
	if(!g) return [];
	if(g.ref){
		return [
			`${g.ref.asset}@${g.ref.version}`
		];
	}
	return [];
};